class OTFControlButtonMove {
    button = '[otf-button-move]';

    constructor() {
        $(this.button).on('click', (event) => {
            let id   = event.target.getAttribute('data-id');
            let type = event.target.getAttribute('data-type');
            if (type === 'section') {
                wp.customize.section(id).expand();
            } else if (type === 'control') {
                this.moveControl(id, type);
            }
        })


        wp.customize.previewer.bind('preview-move', (data) => {
            if (data.type === 'section') {
                if(wp.customize.section(data.id)){
                    wp.customize.section(data.id).expand();
                }
            } else if (data.type === 'control') {
                this.moveControl(data.id, data.trigger);
            }
        });
    }

    /**
     *
     * @param id
     */
    moveControl(id, trigger) {
        let control = wp.customize.control(id);
        control.expand();
        setTimeout(() => {
            if(trigger){
                trigger = trigger.split('|');
                if(trigger.length > 1){
                    $(`${control.selector} ${trigger[0]}`).trigger(trigger[1]);
                }
            }else{
                let $input   = $('input,select, button, textarea', control.selector).first();
                let tmpValue = $input.val();
                $input.focus();
                $input.val('');
                $input.val(tmpValue);
            }
        }, 550);

    }
}